import React from "react";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { AccessibilityHiddenImg, AccessibilityClickableDiv } from '@skillz/accessibility';
import { calculateTotalScore, removeSlashes } from "../../../../utils/utils";
import logo from '../../../../assests/logo.png'
import HeaderContent from "../../header/headerContent/HeaderContent";
import pathRouts from "../../../../enums/pathRoute";
import TitlePages from "../../shared/titlePages/TitlePages";
import PointsScore from "../../shared/pointsScore/PointsScore";
import UserProfile from "../../shared/userProfile/UserProfile";
import AccessibilityStatement from "../../../shared/accessibilityStatement/AccessibilityStatement";
import classes from "./HeaderMobile.module.css"
import Icon from "../../../ui/icons/Icon";
import iconsList from "../../../ui/icons/iconsList";

const HeaderMobile = () => {

    const navigate = useNavigate();
    const { pathname } = useLocation();
    const { texts, lang } = useSelector(state => state.translate);
    const { user, isStudent } = useSelector((state) => state.auth);
    const gamification = useSelector((state) => state.gamification);
    const isHome = removeSlashes(pathname) === pathRouts.HOME.route;

    return (
        <div className={`${classes.HeaderMobile} ${isHome ? classes.HomePage : ""}`}>
            <div className={classes.HeaderContent}>
                <div className={classes.Texts}>
                    {isHome ?
                        <p className={classes.HellowText}>{`${user?.given_name} ${user?.family_name},`}</p> :
                        <TitlePages pathname={pathname} showBackArrow />}
                </div>

                <div className={classes.Content}>
                    {/* {isStudent ? <PointsScore score={calculateTotalScore(gamification?.providers, "score")} /> : ''} */}
                    <UserProfile />

                    {isHome ?
                        <a aria-label={texts.accessibilityStatement} target="_blank" href={`https://www.gov.il/${lang}/pages/accessibility_edu`}>
                            <Icon size='34px' className={classes.AccessibilityStatementIcon} name={iconsList.accessibility} tooltip={texts.accessibilityStatement} />
                        </a>
                        :
                        <AccessibilityClickableDiv accessibilityDescription={texts.home} onClick={() => navigate(pathRouts.HOME.route)}>
                            <div className={classes.LogoWrapper}><AccessibilityHiddenImg src={logo} /></div>
                        </AccessibilityClickableDiv>
                    }
                </div >

            </div >
            {/* {!isHome && <HeaderContent />} */}
        </div >
    )
}

export default HeaderMobile;